import React from 'react'
import healthcare1 from '../images/spg-1.png';
import healthcare2 from '../images/spg2.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function StrategyPowerGroup() {
  return (
    <>
      <section id="portfolio" className="container my-5">
        <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
          <div className="px-3 fw-bold responsive-heading">
            <span className="highlight-orange">Strategy Power Group</span> – Custom Marketing Automation Software
          </div>

        </div>
      </section>

      <section className="container my-5">
        {/* Section 1: Project Overview */}
        <div className="row g-0 overflow-hidden shadow rounded">
          <div className="col-12 col-md-5">
            <img
              src={healthcare1}
              alt="Remente App Overview"
              className="img-fluid w-100 h-100 object-fit-cover"
            />
          </div>

          <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
            <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
              <span className="highlight-orange">Strategy Power Group</span> – Custom Marketing Automation Software
            </h1>

            <p className="mb-3 ps-1">
              Strategy Power Group is a fully customized marketing automation software designed to streamline lead generation,
              nurture customer relationships, and boost business conversions with intelligent automation tools.
            </p>

            <p className="mb-3 ps-1">
              From automated email sequences and campaign tracking to CRM integration and real-time analytics, the platform helps
              businesses simplify their marketing workflow and achieve faster and more predictable growth.
            </p>

            <a
              href="/contact-us"
              className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
            >
              Contact Us
            </a>
          </div>
        </div>

        {/* Section 2: Summary & Team Info */}
        <div className="row g-0 overflow-hidden shadow rounded my-5">
          <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
            <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
              <span className="highlight-orange">Client:</span> Strategy Power Group
            </h1>

            <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
            <p className="mb-3 ps-3">India</p>

            <h4 className="fw-bold mb-1 highlight-orange">Technology & Purpose</h4>
            <p className="mb-3 ps-3">
              Marketing Automation Engine, CRM Integration, Workflow Automation, React, Node.js, Firebase, REST APIs, Analytics Dashboard
            </p>

            <h4 className="fw-bold mb-1 highlight-orange">Domain</h4>
            <p className="mb-3 ps-3">Marketing & Business Automation</p>

            <h4 className="fw-bold mb-1 highlight-orange">Team Involvement</h4>
            <p className="mb-3 ps-3">
              UI/UX Designer, 2 Frontend Engineers, Backend Developer, Automation Specialist, Data Analyst, QA Engineer
            </p>

            <h4 className="fw-bold mb-1 highlight-orange">Duration</h4>
            <p className="mb-4 ps-3">4 Months</p>

            <p className="mb-4 ps-3">
              Strategy Power Group is a custom-built marketing automation platform designed to streamline business operations through automated workflows,
              intelligent lead nurturing, CRM syncing, and real-time performance analytics.
              The software helps businesses improve conversion rates, manage customer journeys, and automate repetitive marketing tasks — ensuring faster growth
              with minimal manual effort.
              With a powerful dashboard, integrated communication tools, and data-driven insights, the platform enables organizations to run smarter,
              more efficient marketing campaigns.
            </p>


            <a
              href="/contact-us"
              className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
            >
              Contact Us
            </a>
          </div>

          <div className="col-12 col-md-5">
            <img
              src={healthcare2}
              alt="Remente UI"
              className="img-fluid w-100 h-100 object-fit-cover"
            />
          </div>
        </div>

        {/* Section 3: Process & Key Features */}
        <div className="row g-0 overflow-hidden shadow rounded my-5">
          <div className="col-12 col-md-5">
            <img
              src={healthcare3}
              alt="Mental Wellness Features"
              className="img-fluid w-100 h-100 object-fit-cover"
            />
          </div>

          <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
            <h1 className="fw-bold mb-3">
              <span className="highlight-orange">Process</span>
            </h1>

            <p className="mb-3 ps-1">
              We built the Strategy Power Group automation system with a performance-driven, scalability-focused approach.
              The platform integrates CRM data, automated workflows, and analytics engines to streamline marketing operations
              for businesses of all sizes. Our architecture ensures high reliability, smooth data synchronization, and real-time processing.
            </p>

            <p className="mb-3 ps-1">
              A clean and intuitive UI/UX was designed to simplify complex marketing tasks — enabling teams to create workflows,
              manage leads, launch automation campaigns, and monitor performance without technical expertise.
              The interface is optimized for speed, clarity, and seamless navigation.
            </p>

            <h4 className="fw-bold mb-2 highlight-orange">Key Features</h4>
            <ul className="ps-3 mb-4">
              <li className="mb-1">Automated lead nurturing workflows</li>
              <li className="mb-1">Email/SMS campaign automation</li>
              <li className="mb-1">CRM syncing and customer journey tracking</li>
              <li className="mb-1">Advanced analytics dashboard with real-time insights</li>
              <li className="mb-1">Custom workflow builder with triggers & actions</li>
            </ul>


            <a
              href="/contact-us"
              className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
            >
              Get Started
            </a>
          </div>
        </div>

        <OurPartner />
      </section>

    </>
  )
}

export default StrategyPowerGroup